export default defineNuxtPlugin(() => {
  if (process.client) {
    const { trackCookieConsentAccepted } = usePosthogFunnel()
    window.addEventListener('click', (event) => {
      const path = event.composedPath()
      const isConsentClick = path.some((el) => {
        const id = (el as HTMLElement).id
        return id === 'cmpbntyestxt' || id === 'cmpwelcomebtnyes'
      })

      if (isConsentClick) {
        trackCookieConsentAccepted({
          button_id: 'cmpbntyestxt',
          location: window.location.href
        })
      }
    }, { capture: true })
  }
})
